import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Popover } from '@/shared/ui';

import styles from './RawMeshViewerActionsPopover.module.scss';

type RawMeshViewerActionsPopoverProps = {
  canDelete: boolean;
  className?: string;
  testID?: string;
  onShowInfo: () => void;
  onRemove: () => void;
};

export const RawMeshViewerActionsPopover: FC<
  RawMeshViewerActionsPopoverProps
> = (props) => {
  const { canDelete, className, testID, onShowInfo, onRemove } = props;

  const [isOpen, setIsOpen] = useState(false);

  const handleShowInfo = (event: React.MouseEvent) => {
    event.stopPropagation();
    onShowInfo();
    setIsOpen(false);
  };

  const handleRemove = (event: React.MouseEvent) => {
    event.stopPropagation();
    onRemove();
    setIsOpen(false);
  };

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      className={className}
      testID={testID}
      popoverClassName={styles.popover}
      iconClassName={styles.detailsIcon}
    >
      <Button
        onClick={handleShowInfo}
        variant="tertiary"
        size="small"
        icon={'info'}
        className={styles.popoverButton}
      >
        <FormattedMessage
          id="reportCard.information"
          defaultMessage="Information"
        />
      </Button>

      {canDelete && (
        <Button
          onClick={handleRemove}
          variant="tertiary"
          size="small"
          danger
          icon={'delete'}
          className={styles.popoverButton}
        >
          <FormattedMessage id="reportCard.remove" defaultMessage="Remove" />
        </Button>
      )}
    </Popover>
  );
};
